var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
var ResponsiveImage = /** @class */ (function (_super) {
    __extends(ResponsiveImage, _super);
    function ResponsiveImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ResponsiveImage.prototype, "srcset", {
        get: function () {
            var crops = this.$props.crops;
            if (crops.length === 0)
                return undefined;
            var src = getMediaUrl(this.$props.src);
            var srcset = "";
            crops
                .forEach(function (p) { return srcset += ", " + src + "?width=" + p.width + " " + p.width + "w"; });
            return srcset.substr(", ".length);
        },
        enumerable: true,
        configurable: true
    });
    ResponsiveImage.prototype.convertToPercent = function (value) {
        value = Math.round(value * 100);
        return value + "%";
    };
    __decorate([
        Prop({ type: String, required: true })
    ], ResponsiveImage.prototype, "src", void 0);
    __decorate([
        Prop({ type: Object, default: function () { return ({ left: 0.5, top: 0.5 }); } })
    ], ResponsiveImage.prototype, "focalPoint", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], ResponsiveImage.prototype, "crops", void 0);
    ResponsiveImage = __decorate([
        Component({
            name: "ResponsiveImage"
        })
    ], ResponsiveImage);
    return ResponsiveImage;
}(Vue));
export default ResponsiveImage;
;
function getMediaUrl(url) {
    var index = url.search(/\/media\//i);
    if (index === -1)
        return url;
    return url.substr(index);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/ResponsiveImage.vue
// module id = 11
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18